import axios from '@plugins/axios'
import getSecret from '@utils/get-secret'

let serverUrl = getSecret('SERVER_URL')


export const state = {
  loading_warehouses: false,
  warehouses: getSavedState('warehouses'),
  own_warehouses: getSavedState('own_warehouses'),
  warehouse_selected: getSavedState('warehouse_selected'),
  own_warehouse_selected: getSavedState('own_warehouse_selected'),
  ubication_selected: getSavedState('ubication_selected'),
  consult_warehouse: getSavedState('consult_warehouse') || true,
  consult_own_warehouse: getSavedState('consult_own_warehouse') || true,
}

export const getters = {
  loading_warehouses: (state) => state.loading_warehouses,
  warehouses: (state) => state.warehouses,
  own_warehouses: (state) => state.own_warehouses,
  warehouse_selected: (state) => state.warehouse_selected,
  own_warehouse_selected: (state) => state.own_warehouse_selected,
  ubication_selected: (state) => state.ubication_selected,
  consult_warehouse: (state) => state.consult_warehouse,
  consult_own_warehouse: (state) => state.consult_own_warehouse,
}

export const mutations = {
  SET_LOADING_WAREHOUSES(state, status) {
    state.loading_warehouses = status
  },
  SET_WAREHOUSES(state, warehouses) {
    state.warehouses = warehouses
    saveState('warehouses', warehouses)
  },
  SET_OWN_WAREHOUSES(state, own_warehouses) {
    state.own_warehouses = own_warehouses
    saveState('own_warehouses', own_warehouses)
  },
  CLEAR_WAREHOUSES(state) {
    state.warehouses = null
    saveState('warehouses', null)
  },
  CLEAR_OWN_WAREHOUSES(state) {
    state.own_warehouses = null
    saveState('own_warehouses', null)
  },
  SET_WAREHOUSE_SELECTED(state, warehouse_selected) {
    state.warehouse_selected = warehouse_selected
    saveState('warehouse_selected', warehouse_selected)
  },
  SET_OWN_WAREHOUSE_SELECTED(state, own_warehouse_selected) {
    state.own_warehouse_selected = own_warehouse_selected
    saveState('own_warehouse_selected', own_warehouse_selected)
  },
  SET_UBICATION_SELECTED(state, ubication_selected) {
    state.ubication_selected = ubication_selected
    saveState('ubication_selected', ubication_selected)
  },
  CLEAR_WAREHOUSE_SELECTED(state) {
    state.warehouse_selected = null
    saveState('warehouse_selected', null)
  },
  CLEAR_OWN_WAREHOUSE_SELECTED(state) {
    state.own_warehouse_selected = null
    saveState('own_warehouse_selected', null)
  },
  CLEAR_UBICATION_SELECTED(state) {
    state.ubication_selected = null
    saveState('ubication_selected', null)
  },
  SET_CONSULT_WAREHOUSE(state, status) {
    state.consult_warehouse = status
    saveState('consult_warehouse', status)
  },
  SET_CONSULT_OWN_WAREHOUSE(state, status) {
    state.consult_own_warehouse = status
    saveState('consult_own_warehouse', status)
  },
}

export const actions = {

  init({ state, dispatch }) {
    dispatch('clearWarehouse')
    dispatch('clearOwnWarehouse')
    dispatch('clearUbication')
    dispatch('clearWarehouses')
    dispatch('clearOwnWarehouses')
  },

  setLoadingWarehouses({ commit }, status) {
    commit('SET_LOADING_WAREHOUSES', status)
  },
  fetchWarehouses(context, query) {
    query = query || ''
    return axios.get(`${serverUrl}/APIv1/warehouse/${query}`).then((response) => {
      let warehouses = response.data
      if (query === '?only_with_locations=true' && warehouses.results){
        warehouses.results = warehouses.results.filter(x=>x.ubications && x.ubications.length > 0)
      }
      return warehouses
    })
  },
  fetchOwnWarehouses(context, query) {
    query = query || ''
    return axios.get(`${serverUrl}/APIv1/warehouse/${query}`).then((response) => {
      let warehouses = response.data
      if (warehouses.results){
        warehouses.results = warehouses.results.filter(x=>/^\d+$/.test(x.code))
      }
      return warehouses
    })
  },
  setWarehouses( { commit }, warehouses) {
    commit('SET_WAREHOUSES', warehouses)
  },
  clearWarehouses({commit }) {
    commit('CLEAR_WAREHOUSES', null)
  },
  setOwnWarehouses( { commit }, own_warehouses) {
    commit('SET_OWN_WAREHOUSES', own_warehouses)
  },
  clearOwnWarehouses({commit }) {
    commit('CLEAR_OWN_WAREHOUSES', null)
  },
  selectWarehouse( { commit }, warehouse_selected ) {
    commit('SET_WAREHOUSE_SELECTED', warehouse_selected)
  },
  selectOwnWarehouse( { commit }, owm_warehouse_selected ) {
    commit('SET_OWN_WAREHOUSE_SELECTED', owm_warehouse_selected)
  },
  selectUbication({ commit }, ubication_selected ) {
    commit('SET_UBICATION_SELECTED', ubication_selected)
  },
  clearWarehouse({ commit }) {
    commit('CLEAR_WAREHOUSE_SELECTED', null)
  },
  clearOwnWarehouse({ commit }) {
    commit('CLEAR_OWN_WAREHOUSE_SELECTED', null)
  },
  clearUbication({ commit }) {
    commit('CLEAR_UBICATION_SELECTED', null)
  },
  setConsultWarehouse({ commit }, status) {
    commit('SET_CONSULT_WAREHOUSE', status)
  },
  setConsultOwnWarehouse({ commit }, status) {
    commit('SET_CONSULT_OWN_WAREHOUSE', status)
  },
}

// ===
// Private helpers
// ===

function getSavedState(key) {
  try {
    return JSON.parse(window.localStorage.getItem(key))
  } catch {
    return []
  }
}

function saveState(key, state) {
  try {
    window.localStorage.setItem(key, JSON.stringify(state))
  } catch {
    return []
  }
}